import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import { FilterOpts, MinMax } from "@saleor/types";
import { ContentPlatformEnum } from "@saleor/types/globalTypes";
import {
  createBooleanField,
  createDateField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum InstagramFilterKeys {
  published = "published",
  createTime = "createTime",
  platForm = "platForm"
}
export interface InstagramListFilterOpts {
  published: FilterOpts<boolean>;
  createTime: FilterOpts<MinMax>;
  platForm: FilterOpts<ContentPlatformEnum[]>;
}
const messages = defineMessages({
  platForm: {
    defaultMessage: "Platform",
    description: "ins"
  },
  createTime: {
    defaultMessage: "Created",
    description: "ins"
  },
  published: {
    defaultMessage: "Published",
    description: "ins"
  }
});
const platFormMessages = defineMessages({
  ins: {
    defaultMessage: "Instagram",
    description: "ins"
  },
  tt: {
    defaultMessage: "TikTok",
    description: "ins"
  }
});
export function createFilterStructure(
  intl: IntlShape,
  opts: InstagramListFilterOpts
): IFilter<InstagramFilterKeys> {
  return [
    {
      ...createOptionsField(
        InstagramFilterKeys.platForm,
        intl.formatMessage(messages.platForm),
        opts.platForm.value,
        true,
        [
          {
            label: intl.formatMessage(platFormMessages.ins),
            value: ContentPlatformEnum.INSTAGRAM
          },
          {
            label: intl.formatMessage(platFormMessages.tt),
            value: ContentPlatformEnum.TIKTOK
          }
        ]
      ),
      active: opts.platForm.active
    },
    {
      ...createDateField(
        InstagramFilterKeys.createTime,
        intl.formatMessage(messages.createTime),
        opts.createTime.value
      ),
      active: opts.createTime.active
    },
    {
      ...createBooleanField(
        InstagramFilterKeys.published,
        intl.formatMessage(messages.published),
        opts.published.value,
        {
          negative: intl.formatMessage(commonMessages.no),
          positive: intl.formatMessage(commonMessages.yes)
        }
      ),
      active: opts.published.active
    }
  ];
}
